import { render, staticRenderFns } from "./DataSetNavigationMetadata.vue?vue&type=template&id=0ec8c142"
import script from "./DataSetNavigationMetadata.vue?vue&type=script&lang=js"
export * from "./DataSetNavigationMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports